import {
  Microphone,
  User as UserIcon,
  Target,
  Newspaper,
  EnvelopeSimple,
  DownloadSimple,
  MonitorPlay,
  Layout,
  ChatsCircle,
} from "@phosphor-icons/react";

/**
 * Central registry — single source of truth for every MEX Magic agent
 * (wizard kártya). A Műhely (Dashboard) ÉS az Admin pult is ebből dolgozik.
 *
 * Mezők
 * ─────
 *  frontendKey  : a frontend route + UI agent_key (`voice`, `client`, …)
 *  backendKey   : a backend canonical agent_key (`brand_voice`, `avatar`, …)
 *                 — ez kerül az agent_flags collectionbe, ezt használja a
 *                 middleware route-védelem és az axios-interceptor.
 *  layer        : 'foundation' | 'attraction' | 'conversion'
 *  title        : a Műhelyben TÉNYLEGESEN megjelenő wizard kártya neve
 *  description  : ugyanaz a leírás amit a dashboard kártya is mutat
 *  icon         : Phosphor icon komponens
 *  route        : a Műhely kártya hova navigál
 *
 * ⚠ A `frontendKey` és a `backendKey` belső kulcsok — NE nevezd át. Ezek
 * route-okat, contextvar-eket, mentési kulcsokat és data-testid-eket
 * azonosítanak. A user-facing magyar feliratokat csak a `title` és a
 * LAYER_LABELS adja.
 */
export const AGENT_REGISTRY = [
  // ─── Alapozás ───────────────────────────────────────────────
  {
    frontendKey: "voice",
    backendKey: "brand_voice",
    layer: "foundation",
    title: "Márkahang Varázsló",
    description: "Fedezd fel a saját, autentikus márkahangod",
    icon: Microphone,
    route: "/agents/voice",
  },
  {
    frontendKey: "client",
    backendKey: "avatar",
    layer: "foundation",
    title: "Avatar Varázsló",
    description: "Építsd fel az ideális vásárlód teljes profilját",
    icon: UserIcon,
    route: "/agents/client",
  },
  {
    frontendKey: "offer",
    backendKey: "offer",
    layer: "foundation",
    title: "Ajánlat Varázsló",
    description: "Erősebb ajánlat, könnyebb igen",
    icon: Target,
    route: "/agents/offer",
  },
  // ─── Vonzás ─────────────────────────────────────────────────
  {
    frontendKey: "magnet-post",
    backendKey: "magnet_post",
    layer: "attraction",
    title: "Poszt Varázsló",
    description: "Görgetés megállító posztok, valódi beszélgetésért",
    icon: Newspaper,
    route: "/agents/magnet-post",
  },
  {
    frontendKey: "email",
    backendKey: "newsletter",
    layer: "attraction",
    title: "Email Varázsló",
    description: "Emailek, amelyek közelebb hozzák a döntést",
    icon: EnvelopeSimple,
    route: "/agents/email",
  },
  {
    frontendKey: "lead-magnet",
    backendKey: "lead_magnet",
    layer: "attraction",
    title: "Ügyfélmágnes Varázsló",
    description: "Mini anyag egy gyors győzelemért",
    icon: DownloadSimple,
    route: "/agents/lead-magnet",
  },
  // ─── Konverzió (felhasználói label — belül 'conversion') ────
  {
    frontendKey: "webinar",
    backendKey: "webinar",
    layer: "conversion",
    title: "Webinár Varázsló",
    description: "Szerezz ügyfelet online előadással",
    icon: MonitorPlay,
    route: "/agents/webinar",
  },
  {
    frontendKey: "landing",
    backendKey: "landing",
    layer: "conversion",
    title: "Landing Varázsló",
    description: "Hatékony ügyfélszerző oldalak",
    icon: Layout,
    route: "/agents/landing",
  },
  {
    frontendKey: "sales",
    backendKey: "sales",
    layer: "conversion",
    title: "Sales Mesterműhely",
    description: "Értékesítő beszélgetések, nyomulás nélkül",
    icon: ChatsCircle,
    route: "/agents/sales",
  },
];

// User-facing label minden rétegnek. Csak label — a belső `conversion`
// kulcs változatlan az adatbázisban + a kódban.
export const LAYER_LABELS = {
  foundation: "Alapozás",
  attraction: "Vonzás",
  conversion: "Konverzió",
};

// Convenience selectors.
export const agentsByLayer = (layer) =>
  AGENT_REGISTRY.filter((a) => a.layer === layer);

export const findByFrontendKey = (k) =>
  AGENT_REGISTRY.find((a) => a.frontendKey === k);

export const findByBackendKey = (k) =>
  AGENT_REGISTRY.find((a) => a.backendKey === k);
